function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32Z",
  fill: "#FBF1D5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4297 26.1719L43.9507 31.6482C43.6071 32.0683 42.9357 31.9473 42.7604 31.4337L42.553 30.8261C42.3264 30.1621 41.3693 30.2183 41.2219 30.9042L40.3802 34.821C40.2183 35.5742 39.1319 35.5388 39.0194 34.7767L37.0464 21.4138C36.9342 20.6542 35.8527 20.6155 35.6865 21.3652L33.1162 32.9613C32.9598 33.6672 31.9617 33.6902 31.7729 32.9922L29.91 26.1033C29.7222 25.409 28.7312 25.4266 28.5683 26.1271L27.0597 32.6119L24.7708 42.7053L23.6559 45.9672C23.4148 46.6728 22.3817 46.5502 22.3124 45.8077L20.8836 30.484C20.8224 29.8267 19.963 29.6205 19.6101 30.1784L18.3158 32.2244C17.9952 32.7312 17.2258 32.618 17.0647 32.0404L16.4297 29.7634",
  stroke: "#D09E0E",
  strokeWidth: 1.07997
});

function SvgStatIconRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatIconRound);
export default __webpack_public_path__ + "static/media/statIconRound.fd1a9d233c7771d99ff62abad544eaaf.svg";
export { ForwardRef as ReactComponent };